import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchQuoteActivity } from '@services/quote.service';
import notify from '@helpers/toastify-helper';
import ActivityTab from '@components/common/acitivity-tab';
import { IActivity } from '@helpers/types/activity';

interface IQuoteActivity {
  activityList: IActivity[];
  isLoading: boolean;
}

const QuoteActivity = () => {
  const params = useParams();
  const [activityState, setActivityState] = useState<IQuoteActivity>({
    activityList: [],
    isLoading: false
  });

  const getQuoteActivity = async (enquiryId: string) => {
    setActivityState((prevState: IQuoteActivity) => ({
      ...prevState,
      isLoading: true
    }));
    const response = await fetchQuoteActivity(enquiryId);
    if (response?.success) {
      setActivityState((prevState: IQuoteActivity) => ({
        ...prevState,
        activityList: response.data,
        isLoading: false
      }));
    } else {
      notify({
        severity: 'error',
        message: response?.message || 'Failed to fetch activity list'
      });
      setActivityState((prevState: IQuoteActivity) => ({
        ...prevState,
        isLoading: false
      }));
    }
  };

  useEffect(() => {
    if (params?.id) {
      getQuoteActivity(params.id);
    }
  }, [params]);

  const { activityList, isLoading } = activityState;

  return (
    <ActivityTab
      activityList={activityList}
      isLoading={isLoading}
      emptyStateConfig={{
        title: 'No Activity performed on this Enquiry yet',
        supportingText: 'When any activity is performed on this Enquiry, it will show up here.',
        buttonText: '',
        to: ''
      }}
      defaultUserName="Elchemy Internal Member"
    />
  );
};

export default QuoteActivity;
